import { Trans } from 'react-i18next';
import { t } from 'utilities/TranslationUtils';
import { useStores } from 'index';

export interface IProductUpdateRowData {
  Date: string;
  DateLabel: string;
  Message: any;
}

export const ReleaseNotesRepo = () => {
  const { profileStore: _profileStore } = useStores();

  const _createAppStoreLink = () => {
    return (
      <a href='https://itunes.apple.com/us/app/trackman-baseball/id1380035760' target='_blank'>
        {t('homePage.see_all_release_notes')}
      </a>
    );
  };

  const CreateOutboundLink = (url: string, text: string, analyticsMessage: string | null = null) => {
    return (
      <a href={url} target='_blank'>
        {text}
      </a>
    );
  };

  const CreateZenDeskLink = (url: string, text: string) => {
    return CreateOutboundLink(url, text, 'Go To Trackman Zendesk');
  };

  const CreateProductUpdateRow = (data: IProductUpdateRowData, index: number) => {
    return (
      <div key={index} className='row'>
        <a href={`#${data.Date}`} id={data.Date} className='col-md-2 col-12'>
          <p className='date'>{t(data.DateLabel)}</p>
        </a>
        <div className='col-md-10 col-12'>
          <>{data.Message}</>
        </div>
      </div>
    );
  };

  const getAllReleaseNotes = (): IProductUpdateRowData[] => [
    {
      Date: '30/05',
      DateLabel: 'homePage.May30th',
      Message: (
        <Trans i18nKey='homePage.ReleaseNoteMay30th'>
          App version 1.0.47 released. New product mode to support women's teams. New 3D view tab in corner kick session. Performance &
          stability improvements
        </Trans>
      ),
    },
  ];

  return {
    _createAppStoreLink,
    CreateOutboundLink,
    CreateZenDeskLink,
    CreateProductUpdateRow,
    getAllReleaseNotes,
  };
};

export default ReleaseNotesRepo;
